import styles from "./EnergyPolicyPage.module.css";

const EnergyPolicyPage = () => {
  return (
    <div className={styles.container}>
      <h1>ΕΝΕΡΓΕΙΑΚΗ ΠΟΛΙΤΙΚΗ</h1>
      <p>
        Η εταιρεία THE RECORDS HUB S.A. δεσμεύεται στη συνεχή βελτίωση της
        ενεργειακής της απόδοσης, την εξοικονόμηση ενέργειας και τη μείωση του
        ενεργειακού της αποτυπώματος, σύμφωνα με τις απαιτήσεις του προτύπου ISO
        50001:2018. Η εταιρεία αναγνωρίζει τη σημασία της βιώσιμης ενεργειακής
        διαχείρισης στις καθημερινές της λειτουργίες.
      </p>
      <p>
        Δεσμευόμαστε να εφαρμόζουμε βέλτιστες πρακτικές ενεργειακής απόδοσης με
        στόχο τη μείωση της κατανάλωσης ενέργειας και την προώθηση της
        βιωσιμότητας.
      </p>
      <h2>Το Σύστημα Διαχείρισης Ενέργειας καλύπτει το παρακάτω πεδίο:</h2>
      <ul>
        <li>
          ΑΣΦΑΛΗΣ ΨΗΦΙΟΠΟΙΗΣΗ ΑΡΧΕΙΩΝ ΠΕΛΑΤΩΝ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΜΑΣ ΣΕ ΕΝΤΥΠΗ ΜΟΡΦΗ
        </li>
        <li>
          ΑΣΦΑΛΗΣ ΦΥΛΑΞΗ ΑΡΧΕΙΩΝ ΠΕΛΑΤΩΝ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΜΑΣ ΣΕ ΕΝΤΥΠΗ Η/ΚΑΙ
          ΗΛΕΚΤΡΟΝΙΚΗ ΜΟΡΦΗ
        </li>
        <li>
          ΑΣΦΑΛΗΣ ΔΙΑΧΕΙΡΙΣΗ ΑΡΧΕΙΩΝ ΠΕΛΑΤΩΝ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΜΑΣ ΣΕ ΕΝΤΥΠΗ Η/ΚΑΙ
          ΗΛΕΚΤΡΟΝΙΚΗ ΜΟΡΦΗ:
        </li>
        <ul>
          <li>ΜΕΤΑΦΟΡΑ</li>
          <li>ΚΑΤΑΓΡΑΦΗ / ΚΑΤΑΛΟΓΟΓΡΑΦΗΣΗ</li>
          <li>ΑΡΧΕΙΟΘΕΤΗΣΗ</li>
          <li>
            ΠΡΟΕΠΙΣΚΟΠΙΣΗ ΚΑΙ ΑΝΑΖΗΤΗΣΗ ΜΕΤΑΔΕΔΟΜΕΝΩΝ ΣΤΗ ΔΙΑΧΕΙΡΙΣΗ ΑΡΧΕΙΩΝ
          </li>
          <li>
            ΑΣΦΑΛΗΣ ΚΑΤΑΣΤΡΟΦΗ ΑΡΧΕΙΩΝ ΠΕΛΑΤΩΝ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΜΑΣ ΣΕ ΕΝΤΥΠΗ Η/ΚΑΙ
            ΗΛΕΚΤΡΟΝΙΚΗ ΜΟΡΦΗ
          </li>
          <li>
            ΣΥΜΒΟΥΛΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗ ΔΙΑΧΕΙΡΙΣΗ ΑΡΧΕΙΩΝ (RECORDS
            MANAGEMENT) ΠΕΛΑΤΩΝ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΜΑΣ
          </li>
          <li>ΣΥΜΒΟΥΛΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ DPO / GDPR</li>
        </ul>
      </ul>
      <h2>Στρατηγικοί στόχοι της εταιρείας είναι:</h2>
      <ul>
        <li>Συνεχής Βελτίωση της Ενεργειακής Απόδοσης.</li>
        <li>Εφαρμογή στρατηγικών εξοικονόμησης ενέργειας.</li>
        <li>
          Συμμόρφωση με Νομοθεσία και Κανονισμούς και με όλους τους σχετικούς
          εθνικούς και διεθνείς κανονισμούς για την ενέργεια και το περιβάλλον.
        </li>
        <li>
          Αξιολόγηση και Παρακολούθηση της Ενεργειακής Απόδοσης με δείκτες
          απόδοσης ώστε να παρακολουθείται και να αξιολογείται τακτικά την
          κατανάλωση ενέργειας.
        </li>
        <li>
          Εκπαίδευση του ανθρώπινου δυναμικού στην αποδοτική χρήση των
          συστημάτων και την ελαχιστοποίηση των απωλειών ενέργειας.
        </li>
      </ul>
      <p>
        Η εταιρεία δεσμεύεται να διασφαλίσει ότι το προσωπικό και οι συνεργάτες
        της κατανοούν την Ενεργειακή Πολιτική και είναι ενεργοί συμμετέχοντες
        στην επίτευξη των στόχων ενεργειακής διαχείρισης.
      </p>
      <p>
        Επιπλέον, θα πραγματοποιούνται τακτικοί εσωτερικοί έλεγχοι για την
        επαλήθευση της συμμόρφωσης με την πολιτική αυτή και για την αξιολόγηση
        των αποτελεσμάτων των πρωτοβουλιών που λαμβάνονται για την ενεργειακή
        βελτίωση.
      </p>
      <p>
        Η Ενεργειακή Πολιτική επανεξετάζεται ετησίως από τη διοίκηση για να
        διασφαλιστεί ότι συνεχίζει να είναι κατάλληλη και σύμφωνη με τις
        επιχειρηματικές ανάγκες της εταιρείας, τις κανονιστικές απαιτήσεις και
        τις νέες τεχνολογικές εξελίξεις.
      </p>
    </div>
  );
};
export default EnergyPolicyPage;
